<div class="container-fluid form-container">
  <div class="container px-md-1">
    <div class="row justify-content-center">
      <div class="col-lg-9 col-md-11 col-12">
        <div class="contact-card p-md-5">

          <!-- Title and Subtitle -->
          <div *ngIf="showTitles" class="text-center mb-4">
            <h5
              class="contact-card__title"
              [style.text-align]="alignTextBlock"
              [style.color]="titlesColor"
              [style.margin-bottom]="'0.5rem'"
            >
              {{ title }}
            </h5>
            <div
              *ngIf="subtitle"
              [style.text-align]="alignTextBlock"
              [style.color]="secondaryColor"
              [style.margin-bottom]="'2rem'"
              class="subtitle-text"
            >
              {{ subtitle }}
            </div>
          </div>

          <form class="block-form">
            <!-- ===================== Nivel ===================== -->
            <div class="row">
              <div class="col-12 mb-3">
                <div class="form-group">
                  <label for="enrollment-level" class="form-label">
                    {{ levelSectionTitle }}
                    <span class="text-danger">*</span>
                  </label>
                  <select
                    id="enrollment-level"
                    class="form-control form-select px-3"
                    [(ngModel)]="selectedLevelId"
                    name="level"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onLevelChange()"
                  >
                    <option [ngValue]="null">Seleccioná una opción</option>
                    <option *ngFor="let level of visibleLevels" [ngValue]="level.id">
                      {{ level.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- ===================== Mensaje de éxito ===================== -->
            <div
              *ngIf="submittedSuccessfully"
              class="enrollment-success"
              role="status"
            >
              Su solicitud de inscripción ha sido enviada.
              Para realizar una nueva solicitud seleccione un nivel.
            </div>

            <!-- ===================== Campos por nivel ===================== -->
            <ng-container *ngFor="let section of visibleSections">
              <div class="row">
                <div class="col-12 mb-2">
                  <h6 class="block-form__section-title">{{ section.title }}</h6>
                </div>

                <ng-container *ngFor="let field of fieldsForSection(section.id)">
                  <div class="col-12 mb-3" [ngClass]="field.half ? 'col-md-6' : 'col-12'">
                    <div class="form-group">
                      <label [for]="'field-' + field.key" class="form-label">
                        {{ field.label }}
                        <span *ngIf="isRequired(field)" class="text-danger">*</span>
                      </label>

                      <!-- Boolean (Sí / No) -->
                      <select
                        *ngIf="field.type === 'boolean'"
                        [id]="'field-' + field.key"
                        class="form-control form-select px-3"
                        [(ngModel)]="model[field.key]"
                        [name]="field.key"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        <option [ngValue]="null">Seleccioná</option>
                        <option [ngValue]="true">Sí</option>
                        <option [ngValue]="false">No</option>
                      </select>

                      <!-- Long text -->
                      <textarea
                        *ngIf="field.type === 'textarea'"
                        [id]="'field-' + field.key"
                        class="form-control px-3"
                        [class.is-invalid]="submitAttempted && fieldError(field)"
                        rows="4"
                        [placeholder]="placeholderFor(field)"
                        [(ngModel)]="model[field.key]"
                        [name]="field.key"
                        [ngModelOptions]="{ standalone: true }"
                      ></textarea>

                      <!-- Text / date / email / tel -->
                      <input
                        *ngIf="field.type !== 'boolean' && field.type !== 'textarea'"
                        [id]="'field-' + field.key"
                        [type]="field.type === 'date' ? 'date' : (field.type === 'email' ? 'email' : (field.type === 'tel' ? 'tel' : 'text'))"
                        class="form-control px-3"
                        [class.is-invalid]="submitAttempted && fieldError(field)"
                        [attr.inputmode]="field.key.endsWith('_dni') || field.type === 'tel' ? 'numeric' : null"
                        [placeholder]="placeholderFor(field)"
                        [(ngModel)]="model[field.key]"
                        [name]="field.key"
                        [ngModelOptions]="{ standalone: true }"
                      />

                      <!-- Validation message -->
                      <small
                        *ngIf="submitAttempted && fieldError(field)"
                        class="text-danger d-block mt-1"
                      >{{ fieldError(field) }}</small>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>

            <!-- ===================== reCAPTCHA + Enviar ===================== -->
            <div class="row" *ngIf="selectedLevelId">
              <div class="col-12 d-flex flex-column align-items-center">
                <re-captcha
                  [siteKey]="recaptchaSiteKey"
                  (resolved)="onCaptchaResolved($event)"
                ></re-captcha>
                <button
                  type="button"
                  class="btn btn-info btn-lg px-5 block-form__submit mt-3"
                  [disabled]="submitting"
                  (click)="onSubmit()"
                >
                  <span>{{ submitting ? 'Enviando...' : buttonText }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
